import {
  AMBER,
  BLACK,
  BLUE,
  BLUEGREY,
  BROWN,
  CAUTION_DARK,
  CYAN,
  DEEPORANGE,
  DEEP_PURPLE,
  GREEN,
  GREY,
  INDIGO,
  LIGHTGREEN,
  LIGHT_BLUE,
  LIME,
  ORANGE,
  PINK,
  PURPLE,
  RED,
  TEAL,
  WARNING_DARK,
  WHITE,
  YELLOW,
} from "../defaultColors/defaultColors";

export const palette = {
  primary: {
    main: CYAN[900],
    light: CYAN[50],
    dark: CYAN[1000],
    accent: CYAN[500],
    medium: CYAN[700],
    contrastText: WHITE,
  },
  secondary: {
    main: BLUE[700],
    dark: BLUE[900],
    light: BLUE[50],
    contrastText: WHITE,
  },
  info: {
    main: BLUE[800],
    accent: BLUE[500],
    light: BLUE[50],
    contrastText: WHITE,
  },
  success: {
    main: GREEN[700],
    accent: GREEN[500],
    light: GREEN[50],
    contrastText: WHITE,
  },
  caution: {
    dark: CAUTION_DARK,
    main: YELLOW[700],
    accent: YELLOW[400],
    light: YELLOW[50],
    contrastText: WHITE,
  },
  warning: {
    dark: WARNING_DARK,
    main: ORANGE[700],
    accent: ORANGE[400],
    light: ORANGE[50],
    contrastText: WHITE,
  },
  error: {
    main: RED[700],
    accent: RED[500],
    light: RED[50],
    contrastText: WHITE,
  },
  hold: {
    main: DEEP_PURPLE[800],
    accent: DEEP_PURPLE[400],
    light: DEEP_PURPLE[50],
    contrastText: WHITE,
  },
  teal: {
    main: TEAL[700],
    accent: TEAL[400],
    light: TEAL[50],
    dark: TEAL[900],
    contrastText: WHITE,
  },
  blue: {
    main: BLUE[700],
    dark: BLUE[900],
    light: BLUE[50],
    accent: BLUE[300],
    contrastText: WHITE,
    medium: BLUE[600],
  },
  green: {
    main: GREEN[700],
    dark: GREEN[900],
    light: GREEN[50],
    accent: GREEN[200],
    medium: GREEN[500],
    darkAccent: GREEN[800],
    mediumLight: GREEN[100],
    contrastText: WHITE,
  },
  red: {
    main: RED[700],
    dark: RED[900],
    light: RED[50],
    accent: RED[200],
    medium: RED[500],
    darkAccent: RED[800],
    mediumLight: RED[100],
    contrastText: WHITE,
  },
  white: {
    main: WHITE,
    dark: WHITE,
    light: WHITE,
    contrastText: BLACK,
  },
  black: {
    main: BLACK,
    dark: BLACK,
    light: GREY[900],
    contrastText: WHITE,
  },
  cyan: {
    main: CYAN[500],
    light: CYAN[50],
    dark: CYAN[900],
    contrastText: WHITE,
  },
  grey: {
    main: GREY[700],
    light: GREY[50],
    mediumLight: GREY[100],
    lightAccent: GREY[200],
    accent: GREY[300],
    darkAccent: GREY[400],
    darkerAccent: GREY[500],
    medium: GREY[600],
    dark: GREY[800],
    contrastText: WHITE,
  },
  purple: {
    main: PURPLE[700],
    light: PURPLE[50],
    dark: PURPLE[900],
    contrastText: WHITE,
  },
  deepPurple: {
    main: DEEP_PURPLE[700],
    light: DEEP_PURPLE[50],
    darkAccent: DEEP_PURPLE[800],
    dark: DEEP_PURPLE[900],
    medium: DEEP_PURPLE[500],
    contrastText: WHITE,
  },
  indigo: {
    main: INDIGO[700],
    light: INDIGO[50],
    dark: INDIGO[900],
    medium: INDIGO[500],
    contrastText: WHITE,
  },
  orange: {
    main: ORANGE[700],
    light: ORANGE[50],
    dark: ORANGE[900],
    darkAccent: ORANGE[800],
    mediumLight: ORANGE[100],
    medium: ORANGE[500],
    contrastText: WHITE,
  },
  bluegrey: {
    main: BLUEGREY[500],
    medium: BLUEGREY[700],
    dark: BLUEGREY[900],
    light: BLUEGREY[100],
    extraLight: BLUEGREY[50],
    contrastText: WHITE,
  },
  amber: {
    main: AMBER[700],
    dark: AMBER[900],
    light: AMBER[50],
    extraLight: AMBER[100],
    contrastText: WHITE,
  },
  pink: {
    main: PINK[500],
    dark: PINK[900],
    light: PINK[50],
    contrastText: WHITE,
  },
  lightblue: {
    main: LIGHT_BLUE[500],
    dark: LIGHT_BLUE[800],
    light: LIGHT_BLUE[100],
    extraLight: LIGHT_BLUE[50],
    contrastText: WHITE,
  },
  yellow: {
    main: YELLOW[500],
    medium: YELLOW[600],
    dark: YELLOW[800],
    light: YELLOW[100],
    lightAccent: YELLOW[50],
    contrastText: WHITE,
  },
  lime: {
    main: LIME[500],
    dark: LIME[900],
    light: LIME[50],
    extraLight: LIME[100],
    medium: LIME[700],
    contrastText: WHITE,
  },
  lightGreen: {
    main: LIGHTGREEN[500],
    dark: LIGHTGREEN[900],
    light: LIGHTGREEN[50],
    extraLight: LIGHTGREEN[100],
    medium: LIGHTGREEN[700],
    contrastText: WHITE,
  },
  brown: {
    main: BROWN[500],
    dark: BROWN[900],
    light: BROWN[50],
    extraLight: BROWN[100],
    medium: BROWN[700],
    contrastText: WHITE,
  },
  deepOrange: {
    main: DEEPORANGE[500],
    dark: DEEPORANGE[900],
    light: DEEPORANGE[50],
    extraLight: DEEPORANGE[100],
    medium: DEEPORANGE[700],
    contrastText: WHITE,
  },
  overlay: {
    main: "rgba(0, 0, 0, 0.2)",
    dark: "rgba(0, 0, 0, 0.5)",
    light: "rgba(255, 255, 255, 0.2)",
  },
  shadow: {
    main: "rgba(153, 153, 153, 0.20)",
  },
  common: {
    white: WHITE,
    black: BLACK,
  },
  vibrant: {
    blue_10: LIGHT_BLUE[500],
    blue_40: CYAN[500],
    blue_50: BLUEGREY[500],
    green_10: GREEN[500],
    green_30: LIME[500],
    neutral_10: BROWN[500],
    orange_10: DEEPORANGE[500],
    orange_20: AMBER[500],
    orange_30: ORANGE[500],
    purple_10: DEEP_PURPLE[500],
    purple_30: PURPLE[500],
    red_10: PINK[500],
    red_20: PINK[300],
    teal_10: CYAN[200],
    teal_20: TEAL[500],
    light_blue_a50: LIGHT_BLUE.a50,
  },
};
